import { combineReducers } from "redux";
import settings from "./settings/Reducer";
import notesReducer from "./notes/Reducer";
import maintodoReducer from "./todos/Todos";
import todoReducer from "./todos/";
import userReducer from "./users/userReducer";
import productsReducer from "./tablas/TablasReducer";
import validacionReducer from "./tablas/ValidacionesReducer"

const Reducers = combineReducers({
  settings,
  notesReducer,
  todoReducer,
  maintodoReducer,
  userReducer,
  productsReducer,
  validacionReducer
});

export default Reducers;
